import { useContext, useEffect, useState } from "react";
import AuthContext from "../../context/AuthContext";
import PageContent from "../../components/PageContent";
import ListPageToolbar from "../../components/ListPageToolbar";
import { useConstants } from "../../hooks/UseConstants";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import PageHero from "../../components/motion/PageHero";
import ScrollReveal from "../../components/motion/ScrollReveal";
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import GridMediaCard from "../../components/cards/GridMediaCard";
import { resolveCourseImage } from "../../helper/resolveMediaUrl";
import Fetch from "../../services/Fetch";
import { useNavigate } from "react-router-dom";
import AlertDialog from "../../components/DialogView";
import SnackbarAlert from "../../components/SnackBar";
import { useDialog } from "../../hooks/UseDialog";
import useSnackBar from "../../hooks/UseSnackBar";
import { useWaits } from "../../hooks/UseWait";
import { parsePaginatedResponse } from "../../utils/parsePaginatedResponse";
import { formatCurrency } from "../../helper/formatCurrency";

function Paths() {
     const { host, language } = useConstants();
     const { wait } = useContext(AuthContext);
     const {open, title, description, setDialog, setOpen} = useDialog();
     const {openSnackBar, type, message, setSnackBar, setOpenSnackBar} = useSnackBar();
     const {getWait, setGetWait, searchWait, setSearchWait, sendWait, setSendWait} = useWaits();
     const [paths, setPaths] = useState([]);
     const [categories, setCategories] = useState([]);
     const [categoryId, setCategoryId] = useState('');
     const [search, setSearch] = useState('');
     const [pathId, setPathId] = useState('');
     const navigate = useNavigate();

     const getCategories = async () => {
          const result = await Fetch(`${host}/categories?per_page=100`, "GET", null);
          const { items } = parsePaginatedResponse(result);
          setCategories(items);
     }

     const getPaths = async () => {
          setSearchWait(true);

          let result;
          if (!categoryId) {
               result = await Fetch(host + `/paths?teacher_id=${localStorage.getItem('id')}&search=${search}`);
          } else {
               result = await Fetch(host + `/paths?teacher_id=${localStorage.getItem('id')}&category_id=${categoryId}&search=${search}`);
          }

          if (result.status == 200) {
               setPaths(result.data.data);
          }

          setSearchWait(false);
     }

     const deletePath = async () => {
          setSendWait(true);

          let result = await Fetch(host + `/teacher/paths/${pathId}/delete`, 'DELETE', null);

          if (result.status == 200) {
               setPaths(prevPaths => prevPaths.filter(path => path.id !== pathId));
               setOpen(false);
               setSnackBar('success','Deleted Successfully');
               setPathId(null);
          }


          setSendWait(false);
     }

     useEffect(() => {
          getCategories();
          getPaths();
          setGetWait(false);
     }, []);

     useEffect(() => {
          getPaths();
     }, [categoryId, search]);

     return (
          <>
               <PageContent wait={wait} loading={getWait}>
                    <PageHero
                        title={language === 'ar' ? 'مساراتي' : 'My Paths'}
                        subtitle={language === 'ar' ? 'إدارة مسارات التعلّم' : 'Manage learning paths'}
                        icon={<AccountTreeOutlinedIcon />}
                    />
                    <ListPageToolbar
                         data={categories}
                         selected={categoryId}
                         onChange={setCategoryId}
                         onSearch={setSearch}
                    />
                    {
                         searchWait ?
                              <Box className="w-full flex justify-center items-center py-16">
                                   <CircularProgress size={70} />
                              </Box>
                              :
                              <Box className="grid grid-cols-3 gap-5 max-sm:grid-cols-1 justify-items-center">
                                   {
                                        paths.map((path, index) => (
                                            <ScrollReveal key={path.id || index} delay={index * 50} direction="up" className="w-full">
                                                            <GridMediaCard
                                                                 image={resolveCourseImage(path)}
                                                                 title={language == 'en' ? path.name_en : path.name_ar}
                                                                 description={language == 'en' ? path.description_en : path.description_ar}
                                                                 footer={
                                                                      <Box>
                                                                           <Typography variant="caption" className="text-blue-600 font-bold">
                                                                                {formatCurrency(path.effective_price ?? path.price, language === 'ar')}
                                                                           </Typography>
                                                                           {path.has_active_discount ? (
                                                                                <Typography variant="caption" color="text.secondary" display="block" sx={{ textDecoration: 'line-through' }}>
                                                                                     {formatCurrency(path.price, language === 'ar')}
                                                                                </Typography>
                                                                           ) : null}
                                                                      </Box>
                                                                 }
                                                                 actions={
                                                                      <>
                                                                           <Button onClick={() => navigate(`/path-details/${path.id}`)} size="small">View</Button>
                                                                           <Button onClick={() => navigate(`/update-path/${path.id}`)} size="small">Update</Button>
                                                                           <Button size="small" color="error" onClick={() => { setPathId(path.id); setDialog('Delete Course', 'Are you sure that you want to delete this course?') }}>Delete</Button>
                                                                      </>
                                                                 }
                                                            />
                                            </ScrollReveal>
                                                       ))
                                   }
                              </Box>
                    }
                    <AlertDialog title={title} description={description} onCancel={() => setOpen(false)} onConfirm={deletePath} wait={sendWait} openDialog={open} />
               </PageContent>
               <SnackbarAlert open={openSnackBar} message={message} severity={type} onClose={() => setOpenSnackBar(false)} />
          </>
     );
}

export default Paths;